/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_3Inputs */

const en_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine Translation***`)
};

const fr_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction automatique***`)
};

const de_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maschinelle Übersetzung***`)
};

const it_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione automatica***`)
};

const ru_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Машинный перевод***`)
};

const es_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción automática***`)
};

const zh_cn2_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器翻译***`)
};

const ja_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`機械翻訳***`)
};

const hi_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मशीन अनुवाद***`)
};

const pt_pt2_signup_feature_pro_3 = /** @type {(inputs: Signup_Feature_Pro_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução automática***`)
};

/**
* | output |
* | --- |
* | "Machine Translation***" |
*
* @param {Signup_Feature_Pro_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_3 = /** @type {((inputs?: Signup_Feature_Pro_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_3(inputs)
	if (locale === "de") return de_signup_feature_pro_3(inputs)
	if (locale === "it") return it_signup_feature_pro_3(inputs)
	if (locale === "ru") return ru_signup_feature_pro_3(inputs)
	if (locale === "es") return es_signup_feature_pro_3(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_3(inputs)
	if (locale === "ja") return ja_signup_feature_pro_3(inputs)
	if (locale === "hi") return hi_signup_feature_pro_3(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_3(inputs)
	return en_signup_feature_pro_3(inputs)
});